import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { IPet } from '@/shared/interfaces';
import { PetTypeEnum } from '@/shared/enums';
import { R } from '@/features/profile/ProfileResources.resx';
import { Button } from '@/components';
import { useState } from 'react';
import { PetModal } from '@/features/profile/pets/PetModal';

export function PetsApp(containerQuery: string, pets: IPet[]) {
    const elm = document.querySelector(containerQuery);
    const root = createRoot(elm);
    root.render(<Pets pets={pets} />);
}

type PetProps = {
    pets: IPet[];
};

const iconPath: (petType: PetTypeEnum) => string = (petType) => {
    switch (petType) {
        case PetTypeEnum.Dog:
            return '/images/icons/pet-dog.svg';
        case PetTypeEnum.Cat:
            return '/images/icons/pet-cat.svg';
        case PetTypeEnum.Rabbit:
            return '/images/icons/pet-rabbit.svg';
        case PetTypeEnum.Rodent:
            return '/images/icons/pet-rodent.svg';
        default:
            return '/images/icons/pet-dog.svg';
    }
};

const Pets: ({ pets }: PetProps) => React.ReactNode = ({ pets }) => {
    const [selectedPet, setSelectedPet] = useState<IPet>();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openEditPetModal = (pet: IPet | null): void => {
        setSelectedPet(pet);
        setIsModalOpen(true);
    };
    return (
        <>
            <div
                className="my-5 flex flex-col gap-2"
                aria-describedby="pets-profile-description"
            >
                {pets.map((pet) => (
                    <div
                        className="flex flex-row items-center gap-4"
                        key={pet.Id}
                    >
                        <button
                            className="flex w-full max-w-sm items-center justify-between rounded-2xl border border-grey-300 p-4 text-left hover:bg-grey-100"
                            tabIndex={0}
                            aria-labelledby="pet-name edit-action"
                            onClick={() => openEditPetModal(pet)}
                        >
                            <img
                                className="mr-4 flex-none"
                                width="40"
                                height="40"
                                src={iconPath(pet.Type)}
                                alt=""
                            />
                            <div className="flex-1">
                                <div className="text-lg font-bold leading-tight text-grey-900">
                                    {pet.Name}
                                </div>
                                <div className="text-sm font-normal leading-tight text-grey-700">
                                    {pet.Race}
                                </div>
                            </div>
                            <img
                                id="edit-action"
                                className="flex-none"
                                width="24"
                                height="24"
                                src="/images/icons/edit.svg"
                                alt={R.OpenEditPetModalA11y}
                            />
                        </button>

                        <button aria-labelledby="pet-name delete-action">
                            <img
                                id="delete-action"
                                className="block cursor-pointer"
                                width="24"
                                height="24"
                                src="/images/icons/trash.svg"
                                alt={R.OpenDeletePetModalA11y}
                            />
                        </button>
                    </div>
                ))}
            </div>

            <Button variant="primary" onClick={() => openEditPetModal(null)}>
                {R.AddPet}
            </Button>

            {isModalOpen && (
                <PetModal
                    pet={selectedPet}
                    onClose={() => {
                        setIsModalOpen(false);
                    }}
                ></PetModal>
            )}
        </>
    );
};
